module.exports = __webpack_public_path__ + "img/chase.5cf49524.jpg";